/** JSON discriminator for `configurations.triggers[].type` (AIAgentTriggerType). */
export default Object.freeze({
  GraphEmailReceived: 'graph-email-received',
  AgentEmailReceived: 'agent-email-received',
  /** @deprecated Legacy discriminator — hydrate maps to GraphEmailReceived. */
  EmailReceived: 'email-received',
});
